import type { PropsWithChildren } from "react";
import { useMemo } from "react";

import { translate } from "app/filters/i18nFilter";
import { SIBreadcrumbs } from "app/pages/sales-intelligence/common-components/SIBreadcrumbs/SIBreadcrumbs";
import {
    MANAGE_INTEGRATION_ROUTE,
    MANAGEMENT_CRM_INTEGRATIONS_ROUTE,
} from "app/pages/sales-intelligence/constants/sl_routes";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { BREADCRUMB_MANAGE_INTEGRATION } from "../../../../common-components/export-table/translations";
import { MANAGEMENT_CRMS_AND_CONNECTORS } from "app/pages/sales-intelligence/pages/management/translations/managementKeys";

type ManageIntegrationBreadcrumbsProps = {
    integrationName: Integration;
};

export const ManageIntegrationBreadcrumbs = ({
    integrationName,
    children,
}: PropsWithChildren<ManageIntegrationBreadcrumbsProps>) => {
    const breadcrumbs = useMemo(
        () => [
            {
                state: MANAGEMENT_CRM_INTEGRATIONS_ROUTE,
                title: translate(MANAGEMENT_CRMS_AND_CONNECTORS),
            },
            {
                state: MANAGE_INTEGRATION_ROUTE[integrationName],
                title: translate(BREADCRUMB_MANAGE_INTEGRATION[integrationName]),
            },
        ],
        [integrationName],
    );

    const handleBreadcrumbClick = ({ state }: { state: string }): void => {
        void proNavigator.go(state);
    };

    return (
        <SIBreadcrumbs
            variant="spaceBetween"
            list={breadcrumbs}
            onClick={handleBreadcrumbClick}
            dataAutomation="manage-integration-breadcrumbs"
        >
            {children}
        </SIBreadcrumbs>
    );
};
